import {EventEmitter, Injectable} from '@angular/core';

/**
 * NOTE:
 * This application uses the default JHipster automatic inactivity logout, which is triggered
 * after 30 minutes of server inactivity.
 */
const TIMEOUT_IN_MS = 1000 * 60 * 29;

@Injectable()
export class InactivityService {
    currentCountdown; // Timeout before event emitted
    openModal = new EventEmitter<void>();

    registerUserActivity() {
        if (this.currentCountdown) {
            this._clearCountdown();
        }
        this._startNewCountdown();
    }

    private _clearCountdown() {
        clearTimeout(this.currentCountdown);
    }

    private _startNewCountdown() {
        this.currentCountdown = setTimeout(() => {
            this.openModal.emit();
            }, TIMEOUT_IN_MS);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/modals/inactivity-modal/inactivity.service.ts